import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { type OtButtonVariant } from '@1trading/design-system';
import differenceInDays from 'date-fns/differenceInDays';
import { type PropType, computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { modalVariant, type ModalVariant } from '@exchange/libs/modals/src';
import { FuturesAppropriatenessResult, FuturesAppropriatenessResultStatus } from '@exchange/libs/rest-api/web-api/customer/futures-appropriateness-resource';

type Action = {
  action: string;
  actionFn: () => void;
  actionTestId: string;
  actionVariant?: OtButtonVariant;
};


const __default__ = {
  name: 'FuturesAppropriatenessManualReviewModal',
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  result: { type: Object as PropType<FuturesAppropriatenessResult>, required: true },
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.dark },
},
  emits: ["back", "close", "deposit", "retake"],
  setup(__props, { emit: __emit }) {

const STATUS_ICON_MAP = {
  [FuturesAppropriatenessResultStatus.MANUAL_REVIEW]: 'info-circle-bulk',
  [FuturesAppropriatenessResultStatus.PASSED]: 'tick-circle-bulk',
  [FuturesAppropriatenessResultStatus.FAILED]: 'close-circle-bulk',
} satisfies Record<FuturesAppropriatenessResultStatus, string>;

const props = __props;

const emit = __emit;

const { t, te } = useI18n({ useScope: 'global' });

const statusTranslationKey = computed(() => `status-${props.result.status}${'canRetake' in props.result ? `.canRetake-${props.result.canRetake}` : ''}`);

const action = computed((): Action => {
  const action = t(`ui.futuresAppropriatenessManualReviewModal.${statusTranslationKey.value}.button`);

  switch (props.result.status) {
    case FuturesAppropriatenessResultStatus.PASSED:
      return {
        action,
        actionFn: () => emit('deposit'),
        actionTestId: 'deposit',
        actionVariant: 'success',
      };
    case FuturesAppropriatenessResultStatus.FAILED: {
      if (props.result.canRetake) {
        return {
          action,
          actionFn: () => emit('retake'),
          actionTestId: 'retake',
        };
      }

      return {
        action,
        actionFn: () => emit('close'),
        actionTestId: 'close',
      };
    }
    case FuturesAppropriatenessResultStatus.MANUAL_REVIEW:
    default:
      return {
        action,
        actionFn: () => emit('back'),
        actionTestId: 'back',
      };
  }
});

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _component_x_link_external = _resolveComponent("x-link-external")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_x_button = _resolveComponent("x-button")!
  const _component_x_modal = _resolveComponent("x-modal")!

  return (_openBlock(), _createBlock(_component_x_modal, {
    class: "futures-appropriateness-manual-review-modal",
    title: _unref(t)('ui.futuresAppropriatenessManualReviewModal.title'),
    variant: __props.variant,
    "can-close": "",
    wide: ""
  }, {
    content: _withCtx(() => [
      _createVNode(_component_ot_icon, {
        name: STATUS_ICON_MAP[props.result.status],
        class: _normalizeClass(["futures-appropriateness-manual-review-modal__icon", { 'futures-appropriateness-manual-review-modal__icon--error': props.result.status === _unref(FuturesAppropriatenessResultStatus).FAILED }])
      }, null, 8, ["name", "class"]),
      _createVNode(_component_i18n_t, {
        keypath: `ui.futuresAppropriatenessManualReviewModal.${statusTranslationKey.value}.message.text`,
        tag: "p",
        scope: "global"
      }, _createSlots({ _: 2 }, [
        ('canRetakeFromDate' in props.result)
          ? {
              name: "number",
              fn: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(differenceInDays)(new Date(props.result.canRetakeFromDate), new Date())), 1)
              ]),
              key: "0"
            }
          : undefined,
        (_unref(te)(`ui.futuresAppropriatenessManualReviewModal.${statusTranslationKey.value}.message.linkText`))
          ? {
              name: "linkText",
              fn: _withCtx(() => [
                _createVNode(_component_x_link_external, {
                  href: _ctx.$t(`ui.futuresAppropriatenessManualReviewModal.${statusTranslationKey.value}.message.linkHref`)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`ui.futuresAppropriatenessManualReviewModal.${statusTranslationKey.value}.message.linkText`)), 1)
                  ]),
                  _: 1
                }, 8, ["href"])
              ]),
              key: "1"
            }
          : undefined
      ]), 1032, ["keypath"])
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_x_button, {
        text: action.value.action,
        variant: action.value.actionVariant ?? 'primary',
        onClick: action.value.actionFn
      }, null, 8, ["text", "variant", "onClick"])
    ]),
    _: 1
  }, 8, ["title", "variant"]))
}
}

})